angular.module('zc.projects')

.directive 'zcCampaignSegmentGraph', ($q, $translate, AccessStats, CampaignStats, Chart, currencies) ->
    restrict: 'E'
    require: '?filters'
    scope:
      project : '='
      campaign: '='
      filters : '='
    templateUrl: '/templates/projects.campaigns/views/directives/campaign_segment_graph.html'

    link: (scope, element, attrs) ->
      currency = currencies[scope.project.currency]

      addSessionSeries = (name ,data) ->
        Chart.addSeries scope.sessionChartConfig,
          name: name
          data: data
          tooltip:
            valueSuffix: $translate.instant('projectsCampaigns.directives.campaignSegmentGraph.session')
            valueDecimals: 0

      addCampaignSeries = (name, data) ->
        Chart.addSeries scope.conversionChartConfig,
          name: name
          data: data
          tooltip:
            valueSuffix: currency.suffix
            valueDecimals: currency.fractionSize

      addCampaignStats = (campaign_stats) ->
        if !campaign_stats || campaign_stats.length == 0
          return

        cumulative_delivery_count = 0
        cumulative_delivery_conversion_price = 0
        cumulative_delivery_count_stats = [[campaign_stats[0].start_at, 0]]
        cumulative_delivery_conversion_price_stats = [[campaign_stats[0].start_at, 0]]
        for stats in campaign_stats
          continue if stats.is_control
          cumulative_delivery_count += stats.delivery_count
          cumulative_delivery_conversion_price += stats.conversion_price
          cumulative_delivery_count_stats.push [stats.start_at, cumulative_delivery_count]
          cumulative_delivery_conversion_price_stats.push [stats.start_at, cumulative_delivery_conversion_price]
        addSessionSeries $translate.instant('projectsCampaigns.directives.campaignSegmentGraph.deliveryCount'), cumulative_delivery_count_stats
        addCampaignSeries $translate.instant('projectsCampaigns.directives.campaignSegmentGraph.distributionTargetSales'), cumulative_delivery_conversion_price_stats

      addAccessStats = (access_stats) ->
        if !access_stats || access_stats.length == 0
          return

        cumulative_session_count = 0
        cumulative_conversion_price = 0
        cumulative_session_count_stats = [[access_stats[0].start_at, 0]]
        cumulative_conversion_price_stats = [[access_stats[0].start_at, 0]]
        for stats in access_stats
          cumulative_session_count += stats.session_count
          cumulative_conversion_price += stats.conversion_price
          cumulative_session_count_stats.push [stats.start_at, cumulative_session_count]
          cumulative_conversion_price_stats.push [stats.start_at, cumulative_conversion_price]
        addSessionSeries $translate.instant('projectsCampaigns.directives.campaignSegmentGraph.segmentSessionCount'), cumulative_session_count_stats
        addCampaignSeries $translate.instant('projectsCampaigns.directives.campaignSegmentGraph.segmentSales'), cumulative_conversion_price_stats

      scope.updateData = ->
        from = _.max([scope.campaign.start_at, moment(scope.filters.start_at).toDate()])
        from = moment(from).startOf('day').toDate()
        to = _.min([scope.campaign.end_at, moment(scope.filters.end_at).toDate()])
        to = moment(to).add(1, 'days').startOf('day').toDate()
        $q.all [
          CampaignStats.find
            dimension: 'daily'
            campaign_id: scope.campaign.id
            apikey: scope.campaign.apikey
            start_at: from.valueOf()
            end_at: to.valueOf()
        ,
          AccessStats.findDefault
            apikey: scope.campaign.apikey
            dimension: 'daily'
          ,
            device: AccessStats.handleCampaignDevice(scope.campaign.campaign_device)
            campaign_segment_id: (scope.campaign.segment?.id or null)
            is_control: null
            start_at:
              $gte: from
              $lt: to
        ]
        .then ([campaign_stats, access_stats]) ->
          scope.sessionChartConfig = Chart.getChartConfig 'segment'
          scope.conversionChartConfig = Chart.getChartConfig 'segment'
          scope.sessionChartConfig.series = []
          scope.conversionChartConfig.series = []
          addAccessStats access_stats
          addCampaignStats campaign_stats

      scope.$watch('filters', scope.updateData, true)



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.campaigns/directives/campaign_segment_graph.coffee